import { User } from "../../../../types/gqlTypes/graphql"

/**
 * @deprecated DEPRECATED_MANAGE_ORG_NAV — consumes the old `/manage/organization` user-management nav.
 * Remove or repoint to `/reporting/organization` when that nav is deleted.
 */
export const MANAGE_ORG_PATH = "/manage/organization"

export const convertUsersToOptions = (searchedUsers: User[]) =>
  searchedUsers.map(user => ({
    label: user.id,
    value: user.id
  }))

export const getSelectedUsersPagePath = (user: User, searchParams: string) => {
  const params = new URLSearchParams(searchParams)

  const { districtId, schoolId, id: selectedUser } = user

  params.set("district", districtId)
  params.set("school", schoolId)
  params.set("gua", schoolId)
  params.set("selectedUser", selectedUser)

  let pageName = ""

  switch (user.roles[0]) {
    case "District Admin":
      pageName = "district-admins"
      break
    case "School Admin":
      pageName = "school-admins"
      break
    case "Teacher":
      pageName = "teachers"
      break
    case "Student":
      pageName = "students"
      break
  }

  return pageName
    // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
    ? `${MANAGE_ORG_PATH}/${pageName}${
        user.deleted ? "/restore" : ""
      }?${params.toString()}`
    : null
}
